export default "__VITE_ASSET__ZRcWpEam__"